
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./global');

import 'datatables.net-bs4/js/dataTables.bootstrap4.js';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';

const Vue = require('vue');
window.Vue = Vue;

let VueCookie = require('vue-cookie');
Vue.use(VueCookie);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// BOOTSTRAP COMPONENTS
Vue.component('b-card', require('./components/common/BootstrapCard'));
Vue.component('b-tabs', require('./components/common/BootstrapTabs'));
Vue.component('b-tab', require('./components/common/BootstrapTab'));

// MEASUREMENT MODULE RELATED (DATA-INPUT)
Vue.component('morphed-type-select', require('./components/measurements-module/MorphedTypeSelect.vue'));
Vue.component('nullable-checkbox-input', require('./components/measurements-module/NullableCheckboxInput.vue'));
Vue.component('data-entry', require('./components/measurements-module/entry/DataEntry'));

// BASIC INPUT AND COMMON ELEMENTS
Vue.component('v-select', vSelect);
Vue.component('html-v-select',  require('./components/common/HtmlVueSelect.vue'));
Vue.component('html-v-select-multiple',  require('./components/common/HtmlVueSelectMultiple.vue'));
Vue.component('formula-measurements-select',  require('./components/formula/FormulaMeasurementsSelect.vue'));
Vue.component('datepicker', Datepicker);
Vue.component('measurement-list-editor', require('./components/common/MeasurementListEditor.vue'));

// CHART COMPONENTS
Vue.component('timeseries-card', require('./components/charts/TimeseriesCardComponent.vue'));
Vue.component('simple-chart', require('./components/charts/SimpleChart'));
Vue.component('doughnat-chart-card-component', require('./components/charts/DoughnatChartCardComponent.vue'));
Vue.component('sdg-chart-component', require('./components/indicators/SdgPieChart.vue'));
Vue.component('kpi-chart-component', require('./components/indicators/KpiTimeChart.vue'));

// ORGANIZATION FORM RELATED COMPONENT
Vue.component('organization-contacts-component', require('./components/organizations/OrganizationContactsComponent.vue'));
Vue.component('address-component', require('./components/organizations/AddressComponent.vue'));
Vue.component('file-upload-component', require('./components/files/FileUploadComponent.vue'));

// MAPS
Vue.component('map-card', require('./components/maps/MapCard.vue'));
Vue.component('edit-location', require('./components/maps/EditLocation.vue'));

// TABLE AND RELATED COMPONENTS
Vue.component('card-table', require('./components/table-components/CardTableComponent'));
Vue.component('crud-table', require('./components/common/CrudTable.vue'));

// ASSET REGISTER RELATED COMPONENT
Vue.component('asset-detail', require('./components/asset-register/AssetDetailsComponent'));
Vue.component('asset-register', require('./components/asset-register/AssetRegisterComponent'));


// DATA SET_TYPE AND RELATED COMPONENTS
Vue.component(
    'data-set-type-measurements-wrapper',
    require('./components/measurements-module/data-set-type/DataSetTypeMeasurementsWrapper.vue')
);
Vue.component(
    'data-set-type-measurement-categories',
    require('./components/measurements-module/data-set-type/DataSetTypeMeasurementCategories.vue')
);
Vue.component(
    'data-set-type-measurements',
    require('./components/measurements-module/data-set-type/DataSetTypeMeasurements.vue')
);

// ADMINISTRATIVE UNITS AND RELATED COMPONENTS
Vue.component(
    'administrative-units-map',
    require('./components/maps/AdministrativeUnitsMap.vue')
);
Vue.component(
    'administrative-units-panel',
    require('./components/administrative-units/AdministrativeUnitsPanel.vue')
);
Vue.component(
    'administrative-units-index',
    require('./components/administrative-units/AdministrativeUnitsIndex.vue')
);

// GENERAL ENTITIES AND RELATED COMPONENTS
Vue.component(
    'general-entities-index',
    require('./components/general-entities/GeneralEntitesIndex.vue')
);

// WATER SOURCE AND RELATED COMPONENTS
Vue.component(
    'water-sources-index',
    require('./components/water-source/WaterSourcesIndex.vue')
);
Vue.component('village-filter', require('./components/water-source/VillageFilter.vue'));

// VALIDATION AND RELATED COMPONENTS
Vue.component('validation-filter', require('./components/validation/ValidationValuesFilter.vue'));

// DATA-SET RELATED FILTERS
Vue.component('dataset-filter-select', require('./components/data-set/DataSetWrapper.vue'));
Vue.component('ajax-dataset-filter', require('./components/data-set/AjaxDataSetWrapper.vue'));

Vue.component('welcome-dashboard', require('./components/dashboard/WelcomeDashboard.vue'));
Vue.component('crud-table', require('./components/common/CrudTable.vue'));
Vue.component('user-notifications', require('./components/notifications/UserNotificationsComponent.vue'));

Vue.component('user-admin-unit-select', require('./components/administation/user/AdminUnitSelectComponent.vue'));

new Vue({
    el: '#app',
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js